import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import Icon from "../../../common/icon/icon.component.jsx";

class InvoiceVoidedEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            invoice: this.props.invoice || null,
            modal: '',
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            invoice: nextProps.invoice || null,
        })
    }

    render() {
        return <div className={"row " + this.state.className}>
            <div className={'col-12 d-flex align-items-start'}>
                <div className={'mr-3'}>
                    <h3 className={"m-0 text-danger"}>
                        <Icon value={"times-circle"} />
                    </h3>
                </div>
                <div >
                    <p className={'mb-1'}>
                        <FormattedMessage
                            id="invoice.analytics.events.voided.text"
                            defaultMessage="Invoice {identifier} has been voided"
                            values={{
                                identifier: <strong>{this.state.invoice.attributes.identifier}</strong>,
                            }}
                        />
                    </p>
                    {this.state.invoice.attributes.notes ? <div className={'w-100'}>
                        <blockquote className="blockquote mb-0">
                            <p className="mb-0">{this.state.invoice.attributes.notes.split('\n').map((item, key) => {
                                return <span key={key}>{item}<br /></span>
                            })}</p>
                        </blockquote>
                    </div> : null}
                </div>
            </div>
        </div>
    }
}

export default InvoiceVoidedEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/invoice-voided.component.jsx